import { useQuery } from '@tanstack/react-query'

import { getCategoriesOfPurchaseApplicationTemplate } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks/use-axios'

export const useFetchCategoriesOfPurchaseApplicationTemplate = (
  organizationId: string
) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading } = useQuery({
    enabled: !!organizationId,
    queryFn: () =>
      getCategoriesOfPurchaseApplicationTemplate(axiosInstance, {
        organizationId,
      }),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_CATEGORIES_OF_PURCHASE_APPLICATION_TEMPLATE,
    ],
  })

  return { data, isError, isLoading }
}
